import { Grid } from '@mantine/core';
import { type ReactNode } from 'react';
import { SettingDefinitionMapping, UpdatedSetting } from '../../../resource/resource-base/settings/types';
import { PropertyValidationInformation } from '../../util/PropertyValidationInformation';
import { BasePropertyAdminSettingsComponent } from './BasePropertyAdminSettingsComponent';
import { BasePropertySettingsCategoryComponent } from './BasePropertySettingsCategoryComponent';

export const BasePropertyAdminSettingsView= ({
    children,
    settingDefinitionMapping,
    onSettingChange,
    onCategorySettingsChange,
    propertyValidationInformation,
}: {
    children?: ReactNode | ReactNode[];
    settingDefinitionMapping: SettingDefinitionMapping;
    onSettingChange: (setting: UpdatedSetting) => void;
    onCategorySettingsChange: (category: string, settings: UpdatedSetting[]) => void;
    propertyValidationInformation: PropertyValidationInformation;
}) => {
    return (
        <Grid
            gutter={'md'}
            style={{
                overflow: 'auto',
                alignItems: 'center',
                width: '100%',
            }}
        >
            {settingDefinitionMapping.settings.map((value) => (
                <Grid.Col
                    span={{ base: 12, md: 6 }}
                    key={value.settingDefinition.identifier + value.settingDefinition.settingClass}
                >
                    <BasePropertyAdminSettingsComponent
                        setting={value}
                        onChange={onSettingChange}
                        disabled={false}
                        propertyValidationInformation={{
                            ...propertyValidationInformation,
                            propertyIdentifier: value.settingDefinition.identifier,
                        }}
                    />
                </Grid.Col>
            ))}
            {settingDefinitionMapping.categories.map((categoryDefinition) => (
                <Grid.Col span={6} key={categoryDefinition.identifier}>
                    <BasePropertySettingsCategoryComponent
                        categoryDefinition={categoryDefinition}
                        onCategorySettingsChange={onCategorySettingsChange}
                        onSettingChange={onSettingChange}
                        propertyValidationInformation={propertyValidationInformation}
                    />
                </Grid.Col>
            ))}
            {children && <Grid.Col span={12}>{children}</Grid.Col>}
        </Grid>
    );
};
